import { FC } from 'react'

import { Button, ButtonProps } from 'antd'
import { MenuClosedIcon, MenuOpenedIcon } from '../icons'
import { styled } from 'styled-components'

interface Props extends ButtonProps {
  opened?: boolean
}

const StyledButton = styled(Button)`
  width: fit-content !important;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const BurgerButton: FC<Props> = ({ opened = false, ...otherProps }) => {
  return <StyledButton type="text" icon={opened ? <MenuOpenedIcon /> : <MenuClosedIcon />} {...otherProps} />
}
